import React from "react";
import { useFormikContext } from "formik";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-number-input";
import "./PhoneInput.style.css";

const AppPhoneInput = ({
  label,
  showCountryCode = true,
  className = "",
  namePhone = "phone",
  nameCountryCode = "country_code",
  ...props
}) => {
  const { values, setFieldValue, setFieldTouched, errors, touched } = useFormikContext();

  let value = "";
  if (values[namePhone] && values[nameCountryCode]) {
    const cc = values[nameCountryCode].startsWith("+")
      ? values[nameCountryCode]
      : `+${values[nameCountryCode]}`;
    value = cc + values[namePhone];
  }

  const handleChange = (phone) => {
    if (!phone) {
      setFieldValue(namePhone, "");
      setFieldValue(nameCountryCode, "");
      return;
    }

    try {
      const parsed = parsePhoneNumber(phone);
      setFieldValue(namePhone, parsed.nationalNumber);
      setFieldValue(nameCountryCode, `+${parsed.countryCallingCode}`);
    } catch {
      setFieldValue(namePhone, "");
      setFieldValue(nameCountryCode, "");
    }
  };

  return (
    <>
      {label && <label htmlFor={props.id || namePhone}>{label}</label>}
      <PhoneInput
        {...props}
        id={props.id || namePhone}
        international
        defaultCountry="US"
        countryCallingCodeEditable={false}
        value={value || undefined}
        onChange={handleChange}
        onBlur={() => setFieldTouched(namePhone, true)}
        className={`${className} ${
          touched[namePhone] && errors[namePhone] ? "is-invalid" : ""
        }`}
      />
      {touched[namePhone] && errors[namePhone] && (
        <p className="invalid-feedback d-block">{errors[namePhone]}</p>
      )}
    </>
  );
};

export default AppPhoneInput;
